import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const InputContainer = styled.div`
  width: 100%;
  margin-bottom: 10px;
`;
